/** @format */

import React from "react";
import { Box, Typography } from "@mui/material";

const formatValue = (v) => {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  if (Number.isInteger(n)) return n.toLocaleString();
  return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

// A single headline metric — used instead of a chart when the answer is just
// one number (one data point + one measure). See resolveVisualization.js.
const BigStat = ({ value, label, context }) => (
  <Box
    sx={{
      mt: 1.5,
      mb: 1,
      px: { xs: 2, md: 2.5 },
      py: { xs: 1.5, md: 2 },
      borderRadius: "12px",
      backgroundColor: "#eef2ff",
      border: "1px solid #c7d2fe",
      display: "inline-flex",
      flexDirection: "column",
      minWidth: { xs: "100%", sm: 220 },
    }}
  >
    <Typography
      sx={{
        fontSize: { xs: 26, md: 34 },
        fontWeight: 800,
        color: "#4338ca",
        lineHeight: 1.1,
        letterSpacing: "-0.02em",
        wordBreak: "break-word",
      }}
    >
      {formatValue(value)}
    </Typography>
    <Typography
      sx={{
        mt: 0.5,
        fontSize: 11,
        fontWeight: 700,
        color: "#64748b",
        textTransform: "uppercase",
        letterSpacing: "0.06em",
      }}
    >
      {label}
    </Typography>
    {context && (
      <Typography sx={{ mt: 0.25, fontSize: 11.5, color: "#94a3b8" }}>
        {context}
      </Typography>
    )}
  </Box>
);

export default BigStat;
